module.exports = __webpack_public_path__ + "b7f585caa95a0294e33cbc855db3c77b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/hat-chef.png
// module id = 2717
// module chunks = 0